import React from 'react';
import { Page } from '../Common/Components/Page';
import { TemplateManagementContent } from './Components/TemplateManagementContent';

export const TemplateManagement = (): React.JSX.Element => (
  <Page title={'Templates'} accessKey={'templates'} isSearchable={true}>
    <TemplateManagementContent />
  </Page>
);
